module.exports = __webpack_public_path__ + "img/soepp_logo.45152f1e.png";